import {
  Button,
  CheckboxCard,
  CheckboxCheckedChangeDetails,
  Flex,
  Text,
} from "@chakra-ui/react";
import { useCallback } from "react";
import { IoTrashBinOutline } from "react-icons/io5";

export interface Todo {
  id: number;
  name: string;
  isComplete: boolean;
}

export interface TodoCardProps extends Todo {
  onCompleteChange?: (id: number, checked: boolean) => void;
  onDeleteClick?: (id: number) => void;
}

export function TodoCard({
  id,
  name,
  isComplete,
  onCompleteChange,
  onDeleteClick,
}: TodoCardProps) {
  const checkedChangeHandler = useCallback(
    (checked: CheckboxCheckedChangeDetails) => {
      onCompleteChange?.(id, !!checked.checked);
    },
    [onCompleteChange, id],
  );
  const deleteClickHandler = useCallback(() => {
    onDeleteClick?.(id);
  }, [onDeleteClick, id]);
  return (
    <>
      <CheckboxCard.Root
        w="full"
        onCheckedChange={checkedChangeHandler}
        checked={isComplete}
        variant={"surface"}
        colorPalette="teal"
      >
        <CheckboxCard.HiddenInput />
        <CheckboxCard.Control>
          <CheckboxCard.Indicator />
          <CheckboxCard.Label>
            <Flex w="100%">
              <Text lineClamp="2">{name}</Text>
              <Button
                height="8"
                width="6"
                colorPalette={"gray"}
                marginLeft="auto"
                variant="outline"
                onClick={deleteClickHandler}
              >
                <IoTrashBinOutline />
              </Button>
            </Flex>
          </CheckboxCard.Label>
        </CheckboxCard.Control>
      </CheckboxCard.Root>
    </>
  );
}
